// extracted by mini-css-extract-plugin
export var compact = "kzbqvU7RfJhV8HKzP39S";
export var fullWidth = "hbkGl94JP872f22BOYSw";
export var info = "Kd53X7uRSSQg7crEfvNQ";
export var negative = "VJFq89A_m6JY2yigCOLT";
export var positive = "RlFsHHUHURRy6J2Z6p0q";
export var root = "AmDOYt6E_Ik6Fr7gaXhe";
export var warning = "aV_YSxO0O3iu99iDJOwg";